import React from "react";

const AuthProvider = ({ children }) => {
  return <>{children}</>;
};

export default AuthProvider;
